// Declare action names as constants with uppercase string

import ApiService from 'app/services/ApiService';
export const COURSES_BEGIN = 'COURSES_BEGIN';
export const COURSES_SUCCESS = 'COURSES_SUCCESS';
export const COURSES_FAILURE = 'COURSES_FAILURE';
export const CLEAR_COURSES = 'CLEAR_COURSES';

// Thunk: this is a special type of action that can dispatch other actions
export function fetchCourse(data) {
    return async dispatch => {

        dispatch(coursesBegin());
        await ApiService.setCourses(data)
            .then(
                result => {
                    dispatch(coursesSuccess(result));
                },
            error => {
                dispatch(coursesFailure(error));
                // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'Ops! course creation has failed' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const coursesBegin = () => ({
    type: COURSES_BEGIN
});
export const coursesSuccess = data => ({
    type: COURSES_SUCCESS,
    payload: { data }
});
export const coursesFailure = error => ({
    type: COURSES_FAILURE,
    payload: { error }
});

export const clearCourses = () => ({
    type: CLEAR_COURSES,
});